import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styles: [
  ]
})
export class QuizComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
